var utils = function () {
  var cachedIsMobile = null;
  var clearCachedIsMobile = function clearCachedIsMobile() {
    cachedIsMobile = null;
  };
  return {
    // viewport
    get width() {
      return window.innerWidth;
    },
    get height() {
      return window.innerHeight;
    },
    get scrollTop() {
      return window.pageYOffset || document.documentElement.scrollTop;
    },
    // device
    get isMobile() {
      if (cachedIsMobile === null) {
        cachedIsMobile = window.matchMedia("screen and (max-width: 48em)").matches;
      }
      return cachedIsMobile;
    },
    clearCachedIsMobile: clearCachedIsMobile,
    // animation
    get duration() {
      return 0.6;
    },
    get easing() {
      return 'cubic-bezier(0.5, 0, 0.2, 1)';
    }
  };
}();
export { utils };